import React, { useState, useEffect } from "react";

function Advertisement() {
  const [announcement, setAnnouncement] = useState("");

  useEffect(() => {
    fetch("https://apiv2.chakran.in/api/HomeBannerContent/getHomeContent")
      .then((response) => response.json())
      .then((data) => {
        if (data && data.announcementText) {
          setAnnouncement(data.announcementText);
        }
      })
      .catch((error) => console.error("Error fetching announcement:", error));
  }, []);

  return (
    <div className="container">
      <marquee>{announcement ? announcement : "Loading announcement..."}</marquee>
    </div>
  );
}

export default Advertisement;


// import React from 'react';

// function Advertisement() {
//   return (
//    <div>
//      <div classNmae="container">
//       <marquee>Help Help Help Help Help Help Help Help Help Help Help Help</marquee>
//      </div>
//   </div>
//   );
// }

// export default Advertisement;
